/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win1_DInputs */

const en_wc_vs_win1_d = /** @type {(inputs: Wc_Vs_Win1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word is part of a paid Microsoft 365 plan or a one-time Office purchase. WordCraft costs nothing, on every device, forever.`)
};

/**
* | output |
* | --- |
* | "Word is part of a paid Microsoft 365 plan or a one-time Office purchase. WordCraft costs nothing, on every device, forever." |
*
* @param {Wc_Vs_Win1_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win1_d = /** @type {((inputs?: Wc_Vs_Win1_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win1_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win1_d(inputs)
});
export { wc_vs_win1_d as "wc.vs.win1.d" }